import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22adc90c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "surface-card p-4 shadow-2 border-round" };
const _hoisted_2 = { class: "mb-3 flex flex-column align-items-start md:flex-row md:align-items-center md:justify-content-between" };
const _hoisted_3 = { class: "header-container mb-3 md:mb-0" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-3xl font-medium text-900 mb-3" }, "Import an ACH File", -1));
const _hoisted_5 = { class: "grid p-fluid flex flex-column" };
const _hoisted_6 = { class: "field mb-4 col-6" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "importName",
    class: "font-medium text-900"
}, "Import Name", -1));
const _hoisted_8 = { class: "flex flex-row w-8 gap-8" };
const _hoisted_9 = { class: "field mb-4" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "rules",
    class: "ml-2 mb-0"
}, " Import Without Running Rules ", -1));
const _hoisted_11 = {
    key: 0,
    class: "field mb-4"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "maxCheck",
    class: "ml-2 mb-2"
}, " Ignore Dollar Amounts Over", -1));
const _hoisted_13 = { class: "field mb-4 col-6" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "ACHFile",
    class: "font-medium text-900"
}, "ACH File to Parse", -1));
const _hoisted_15 = { class: "p-inputgroup" };
import { computed, ref } from 'vue';
import useMainStore from '@/store/main.store';
import useImportRecordsStore from '@/store/importRecords.store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileImport',
    emits: ['filePreview'],
    setup(__props, { emit }) {
        const mainStore = useMainStore();
        const importRecordsStore = useImportRecordsStore();
        const importRecord = ref();
        const importStages = [
            { "stage": "Import File", "icon": "pi pi-circle-fill", "color": "#2196F3" },
            { "stage": "Preview", "icon": "pi pi-circle", "color": "#2196F3" },
            { "stage": "Finish", "icon": "pi pi-circle", "color": "#2196F3" }
        ];
        const isImportSelected = computed(() => {
            return importRecord?.value?.file == null;
        });
        const previewImportRecord = (async () => {
            const importRecordObj = {
                importName: importRecord?.value?.importName ?? "",
                fileName: importRecord?.value?.fileName ?? "",
                file: importRecord?.value?.file ?? null,
                importWithoutRules: importRecord?.value?.importWithoutRules ?? false,
                setMaxDollarAmount: importRecord?.value?.setMaxDollarAmount ?? false,
                maxDollarAmount: importRecord?.value?.maxDollarAmount
            };
            if (mainStore.isBusy)
                return;
            await importRecordsStore.previewImportRecord(importRecordObj);
            emit('filePreview');
        });
        importRecord.value = {
            importName: "",
            fileName: "",
            file: null,
            importWithoutRules: false,
            setMaxDollarAmount: false,
        };
        function fileUploaded(event) {
            const defaultImportName = String(new Date().toJSON().slice(0, 10)) + "_Import";
            importRecord.value = {
                importName: importRecord?.value?.importName != "" ? importRecord?.value?.importName ?? "" : defaultImportName,
                fileName: event.files[0].name,
                file: event.files[0],
                importWithoutRules: importRecord?.value?.importWithoutRules ?? false,
                setMaxDollarAmount: importRecord?.value?.setMaxDollarAmount ?? false,
                maxDollarAmount: importRecord?.value?.maxDollarAmount,
            };
        }
        function cancelFileUpload() {
            importRecord.value = {
                importName: "",
                fileName: "",
                file: null,
                importWithoutRules: false,
                setMaxDollarAmount: false,
            };
        }
        return (_ctx, _cache) => {
            const _component_Timeline = _resolveComponent("Timeline");
            const _component_Button = _resolveComponent("Button");
            const _component_InputText = _resolveComponent("InputText");
            const _component_Checkbox = _resolveComponent("Checkbox");
            const _component_InputGroupAddon = _resolveComponent("InputGroupAddon");
            const _component_InputNumber = _resolveComponent("InputNumber");
            const _component_InputGroup = _resolveComponent("InputGroup");
            const _component_FileUpload = _resolveComponent("FileUpload");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createVNode(_component_Timeline, {
                            value: importStages,
                            layout: "horizontal"
                        }, {
                            marker: _withCtx((slotProps) => [
                                _createElementVNode("i", {
                                    class: _normalizeClass(slotProps.item.icon),
                                    style: _normalizeStyle({ color: slotProps.item.color })
                                }, null, 6)
                            ]),
                            content: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.item.stage), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _createVNode(_component_Button, {
                        class: "p-button-info",
                        icon: "pi pi-arrow-right",
                        label: "Parse and Preview",
                        onClick: previewImportRecord,
                        loading: _unref(mainStore).isBusy,
                        disabled: _unref(isImportSelected)
                    }, null, 8, ["loading", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_InputText, {
                            id: "importName",
                            type: "text",
                            modelValue: importRecord.value.importName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((importRecord.value.importName) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_Checkbox, {
                                id: "rules",
                                modelValue: importRecord.value.importWithoutRules,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((importRecord.value.importWithoutRules) = $event)),
                                binary: true
                            }, null, 8, ["modelValue"]),
                            _hoisted_10
                        ]),
                        (importRecord.value.importWithoutRules)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_Checkbox, {
                                    id: "maxCheck",
                                    class: "mb-2",
                                    modelValue: importRecord.value.setMaxDollarAmount,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((importRecord.value.setMaxDollarAmount) = $event)),
                                    binary: true
                                }, null, 8, ["modelValue"]),
                                _hoisted_12,
                                _createVNode(_component_InputGroup, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_InputGroupAddon, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode("$")
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_InputNumber, {
                                            id: "dollarAmount",
                                            placeholder: "Maximum Amount",
                                            disabled: !importRecord.value.setMaxDollarAmount,
                                            min: 0,
                                            max: 2147483647,
                                            modelValue: importRecord.value.maxDollarAmount,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((importRecord.value.maxDollarAmount) = $event))
                                        }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_InputText, {
                                modelValue: importRecord.value.fileName,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((importRecord.value.fileName) = $event)),
                                class: "mr-2"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_FileUpload, {
                                mode: "basic",
                                accept: "text/plain",
                                chooseLabel: "Browse",
                                modelValue: importRecord.value.file,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((importRecord.value.file) = $event)),
                                customUpload: true,
                                onUploader: fileUploaded,
                                auto: true
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_Button, {
                                label: "Cancel",
                                onClick: cancelFileUpload,
                                class: "ml-2 p-button-info"
                            })
                        ])
                    ])
                ])
            ]));
        };
    }
});
